import React from 'react';
import PagesGridActions from './PagesGridActions';

const pagesGridColumns = [
    {
        id: 'id',
        Header: 'Id',
        accessor: 'id',
        width: 70,
    },
    {
        Header: 'Title',
        accessor: 'title',
    },
    {
        Header: 'Page Type',
        accessor: 'type',
        sortable: false,
        Cell: (props) => <span>{props.value}</span>,
    },
    {
        id: 'type_id',
        Header: 'Enabled',
        accessor: 'type_id',
        show: false,
    },
    {
        Header: 'Site',
        accessor: 'site',
        sortable: false,
        Cell: (props) => <span>{props.value}</span>,
    },
    {
        Header: 'Actions',
        width: 200,
        sortable: false,
        Cell: (props) => <PagesGridActions props={props} />,
    },
];

export default pagesGridColumns;



// WEBPACK FOOTER //
// ./src/containers/pages/PagesGridColumns.jsx